
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/502",
      function () {
        return require("private-next-pages/502/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/502"])
      });
    }
  